"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;

var _fp = require("lodash/fp");

var theme = {
  breakpoints: (0, _fp.map)(function (x) {
    return x + 'rem';
  }, [48, 60, 80]),
  colors: {
    black: '#000',
    white: '#fff'
  },
  fonts: {
    sans: 'sans-serif',
    serif: 'serif'
  },
  lineHeights: {
    solid: 1,
    title: 1.2,
    copy: 1.5,
    wide: 1.75
  },
  fontSizes: {
    tiny: '0.8rem',
    small: '0.9rem',
    normal: '1rem',
    medium: '1.25rem',
    large: '2rem',
    xlarge: '2.5rem',
    xxlarge: '3rem'
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    heavy: 800
  },
  maxWidths: {
    medium: '48rem',
    large: '60rem',
    xlarge: '80rem'
  },
  space: (0, _fp.map)(function (n) {
    return n / 2 + 'rem';
  }, (0, _fp.range)(0, 30)),
  transition: '200ms',
  textStyles: {
    caps: {
      textTransform: 'uppercase'
    },
    smallCaps: {
      textTransform: 'uppercase',
      letterSpacing: '0.1em'
    }
  }
};
exports.theme = theme;
theme.boxStyles = {
  lastNoMargin: {
    '&:last-child': {
      marginBottom: 0,
      marginRight: 0
    }
  },
  firstLastNoMargin: {
    '&:first-child': {
      marginTop: 0,
      marginLeft: 0
    },
    '&:last-child': {
      marginBottom: 0,
      marginRight: 0
    }
  }
};
theme.mediaQueries = (0, _fp.mapValues)(function (x) {
  return "@media (min-width: ".concat(x, "px)");
}, theme.mediaSizes);